import api from '@/api';

export default {
  getItemMetadata: function (itemId: string): Promise<recall.ItemMetaData> {
    return api.get({
      url: `/cubelook/recall/api/metadata?itemId=${itemId}`
    })
  },

  requestMainRecall: function (recallRequest: recall.RecallRequest): Promise<ResponseBase> {
    return api.post({
      url: '/cubelook/recall/api/requestrecall',
      data: recallRequest,
    });
  },

  getRecallStatus: function (searchKey: string): Promise<recall.RecallStatusResponse> {
    return api.get({
      url: `/cubelook/recall/api/recallstatus?searchkey=${searchKey}`,
    });
  }
};
